<template>
  <div class="animated fadeIn">
    <!-- <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" /> -->
    <b-card>
      <template v-slot:header>
        <h5>Laporan Saya</h5>
      </template>
      <div class="search-wrapper d-flex align-items-center justify-content-between"></div>
      <div class="search-wrapper d-flex align-items-center mb-3">
        <b-form-group label="Tanggal Mulai" class="mr-2 mt-2 mb-0">
          <b-form-input type="date" v-model="input.startDate" />
        </b-form-group>
        <b-form-group label="Tanggal Akhir" class="mr-2 mt-2 mb-0">
          <b-form-input type="date" v-model="input.endDate" />
        </b-form-group>
        <b-form-group label="Status" class="mr-2 mt-2 mb-0">
          <b-form-select v-model="input.status" :options="statusOptions" />
        </b-form-group>
        <div class="mt-4">
          <b-button
            class="mr-2 mt-2"
            variant="pgiBtn"
            :disabled="isBusy"
            @click="onFilter"
          >
            <i class="fa fa-search"></i>
          </b-button>
          <b-button class="mt-2" variant="pgiBtn" :disabled="isBusy" @click="onReset"
            >Reset</b-button
          >
        </div>
      </div>

      <b-table
        :busy="isBusy"
        :items="laporanData"
        :fields="fields"
        :no-local-sorting="false"
        bordered
        hover
        show-empty
        responsive
        class="mb-3"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Loading data...</strong>
          </div>
        </template>
        <template v-slot:empty> Tidak ada data Laporan Saya. </template>
        <template v-slot:cell(tglBuat)="row">
          {{$helper.changeDateTimeFormat(row.item.tglBuat)}}
        </template>
        <template v-slot:cell(status)="row">
          <b-badge variant="primary" class="p-2" v-if="row.item.status == 1"
            >Proses</b-badge
          >
          <b-badge variant="success" class="p-2" v-else-if="row.item.status == 2"
            >Selesai</b-badge
          >
          <b-badge variant="danger" class="p-2" v-else>Gagal</b-badge>
        </template>
        <template v-slot:cell(action)="row">
          <b-button
            v-if="row.item.status == 2"
            variant="pgiBtn"
            class="mb-0 download-btn"
            @click="confirmDownload(row.item.pathFile)"
          >
            <a>
              <i class="fa fa-download mr-2"></i>
              Download
            </a>
          </b-button>
        </template>
      </b-table>
      <div class="pagination-wrapper d-flex align-items-center justify-content-between">
        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
          <b-form-select
            v-model="input.show"
            id="showItems"
            :options="options"
            @change="onLimitChange"
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled />
            </template>
          </b-form-select>
          <span class="ml-2">{{ totalViewText }}</span>
        </b-input-group>
        <b-pagination
          class="mb-0"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
          @input="onPageChange"
        ></b-pagination>
      </div>
    </b-card>
    <ModalConfirm
      id="modal-confirm-download"
      title="Confirm Download"
      desc="Apakah anda yakin untuk mendownload?"
      @submit="onDownload()"
    />
  </div>
</template>

<script>
export default {
  name: "laporan-saya",
  data() {
    return {
      initStatus: 0,
      isBusy: false,
      isLoading: false,
      fileToDownload: null,
      input: {
        startDate: "",
        endDate: "",
        status: null,
        show: 10,
      },
      statusOptions: [
        { value: null, text: "Semua" },
        { value: 1, text: "Proses" },
        { value: 2, text: "Selesai" },
        { value: 0, text: "Gagal" },
      ],
      laporanData: [],
      fields: [
        { key: "namaLaporan", label: "Nama", sortable: true },
        { key: "tglBuat", label: "Tanggal", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "action", label: "Aksi" },
      ],

      options: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 30, text: "30" },
        { value: 40, text: "40" },
        { value: 50, text: "50" },
      ],
      currentPage: 1,
      perPage: 10,
      rows: null,
      totalViewText: "",
      page: "",
      size: "",
      loading: false,
      query: "",
    };
  },

  methods: {
    onFilter() {
      this.page = 0;
      this.currentPage = 1;
      this.query = this.$helper.makeQuery(0, this.size);
      this.loading = true;
      this.getLaporanSaya();
    },

    getLaporanSaya() {
      //   this.toggleBusy()

      let rawParams = {
        startDate: this.input.startDate,
        endDate: this.input.endDate,
        status: this.input.status,
        search: "",
        page: this.page,
        size: this.size,
      };

      let params = {};
      for (let key in rawParams) {
        if (rawParams[key] !== null && rawParams[key] !== "") {
          params[key] = rawParams[key];
        }
      }

      this.query = new URLSearchParams(params).toString();

      this.$axios
        .get(`request-laporan/get?${this.query}`)
        .then((res) => {
          this.laporanData = res.data.content || [];
          this.updateTotalItem(res.data.totalElements);
        })
        .catch((err) => {
          this.$helper.parseError(this, err);
          this.laporanData = [];
        })
        .finally(() => {
          //   this.toggleBusy();
        });
    },
    updateTotalItem(total) {
      let limit = null;
      let prevLimit = null;
      this.perPage = this.size;
      this.rows = total;
      prevLimit = this.page * this.size + 1;
      limit = this.page * this.size + this.size;
      if (limit > this.rows) limit = this.rows;
      this.totalViewText =
        "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri";
    },
    onLimitChange() {
      this.size = this.input.show;
      this.perPage = this.input.show;
      this.currentPage = 1;
      this.page = 0;
      this.query = this.$helper.makeQuery(0, this.size);
      this.getLaporanSaya();
    },

    onPageChange() {
      if (this.loading == false) {
        this.page = this.currentPage - 1;
        this.query = this.$helper.makeQuery(this.page, this.size);
        this.getLaporanSaya();
      }
    },
    toggleBusy() {
      if (this.isBusy == true) this.isBusy = false;
      else this.isBusy = true;
    },

    onReset() {
      this.input.startDate = "";
      this.input.endDate = "";
      this.input.status = null;
      //   this.laporanData = [];
    },
    confirmDownload(path) {
      this.fileToDownload = path;
      this.$bvModal.show("modal-confirm-download");
    },
    onDownload() {
      if (this.fileToDownload) {
        const link = document.createElement("a");
        link.href = this.$baseFilePath + this.fileToDownload;
        link.download = "";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.fileToDownload = null; // Reset
        this.$bvModal.hide("modal-confirm-download");
      }
    },
  },

  created() {
    this.initStatus = 0;
    this.page = 0;
    this.size = this.input.show;
    this.query = this.$helper.makeQuery(this.page, this.size);
    this.getLaporanSaya();
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
};
</script>
